import Util from '../../shared/util/util';

/**
 *
 * @param {*} day
 * @param {*} timeRegistrationsViewer
 * @returns {any[]}
 */
export const getTimeRegistrationsOfTheDay = (day, timeRegistrationsViewer) => {
	return timeRegistrationsViewer.filter(t => {
		const date = Util.CreateNonUtcMomentDate(t.node.year, t.node.month, t.node.day);
		return date.isSame(day, 'day');
	});
};

export const separateWorkingTimeAndTimeOff = timeRegistrations => {
	const [timeOffRegistration, workingTimeRegistration] = timeRegistrations.reduce(
		([timeOff, workingTime], timeRegs) => (timeRegs.node.idleTime && !timeRegs.node.idleTime.isInternalTime ? [[...timeOff, timeRegs], workingTime] : [timeOff, [...workingTime, timeRegs]]),
		[[], []]
	);

	const timeOffTotalTime = timeOffRegistration.reduce((totalTimeRegistered, timeReg) => totalTimeRegistered + timeReg.node.minutesRegistered, 0);
	const workingTimeTotalTime = workingTimeRegistration.reduce((totalTimeRegistered, timeReg) => totalTimeRegistered + timeReg.node.minutesRegistered, 0);

	return {
		timeOff: timeOffTotalTime,
		workingTime: workingTimeTotalTime,
	};
};

/*
	Find the time registrations made on the same task/project/idle.
	The matching time registrations are then set to null to reduce the calculation
*/
export const findSameTimeRegistrations = (timeRegistrations, timeReg) => {
	return timeRegistrations.reduce((same, t, index) => {
		if (t && timeReg) {
			if (timeReg.node.task && t.node.task && timeReg.node.task.id === t.node.task.id) {
				timeRegistrations[index] = null;
				return [...same, t];
			} else if (timeReg.node.project && t.node.project && timeReg.node.project.id === t.node.project.id) {
				timeRegistrations[index] = null;
				return [...same, t];
			} else if (timeReg.node.idleTime && t.node.idleTime && timeReg.node.idleTime.id === t.node.idleTime.id) {
				timeRegistrations[index] = null;
				return [...same, t];
			} else {
				return same;
			}
		} else {
			return same;
		}
	}, []);
};
